import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { first, from, map, Observable, of, switchMap } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { AppRoutes } from '@core';
import { UpdateService } from '@update/infra';

export const UpdateGuard = (): Observable<boolean> => {
  const router: Router = inject(Router);
  const updateService: UpdateService = inject(UpdateService);

  if (!Capacitor.isNativePlatform()) return of(true);

  return updateService.isUpdated().pipe(
    first(),
    switchMap((isUpdated: boolean) =>
      isUpdated ? of(true) : from(router.navigate([`/${AppRoutes.BLOCKED_VERSION}`])).pipe(map((): boolean => false))
    )
  );
};
